export default __webpack_public_path__ + "static/media/1.66e17866.jpg";